var render = function render(){var _vm=this,_c=_vm._self._c;return _c('home',{attrs:{"endpoint":"productclass","params":_vm.params}})
}
var staticRenderFns = []

export { render, staticRenderFns }